import { render, staticRenderFns } from "./JSBCDemo.vue?vue&type=template&id=f0ee8d7e&scoped=true&"
import script from "./JSBCDemo.vue?vue&type=script&lang=js&"
export * from "./JSBCDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ee8d7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0ee8d7e')) {
      api.createRecord('f0ee8d7e', component.options)
    } else {
      api.reload('f0ee8d7e', component.options)
    }
    module.hot.accept("./JSBCDemo.vue?vue&type=template&id=f0ee8d7e&scoped=true&", function () {
      api.rerender('f0ee8d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/demo/JSBCDemo.vue"
export default component.exports